var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnimation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    strokeWidth: 3.5,
    fillOpacity: 0.4,
    fill: "#000",
    cx: 25,
    cy: 25,
    r: 23.25
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.889 12.963)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.984 17.969a.394.394 0 0 1-.395-.392c0-.103.042-.201.115-.274a.413.413 0 0 1 .562 0c.154.153.154.4-.002.552a.4.4 0 0 1-.28.114Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.024 6.107 11.31.052a.402.402 0 0 0-.397 0L.198 6.107A.39.39 0 0 0 0 6.445v12.11c0 .14.076.268.198.338l10.715 6.055c.122.07.274.07.397 0l10.714-6.055a.39.39 0 0 0 .198-.338V6.445a.39.39 0 0 0-.198-.338ZM11.11.834l9.92 5.611-9.92 5.604-9.92-5.604L11.11.834ZM.794 7.119l9.92 5.608v11.209l-9.92-5.608V7.12Zm10.714 16.817v-11.21l9.92-5.607v11.21l-9.92 5.607Z",
    stroke: "#FFF",
    strokeWidth: 0.926
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.806 13.201a.45.45 0 0 0-.129-.086.4.4 0 0 0-.433.086.386.386 0 0 0 .002.553.4.4 0 0 0 .278.113.346.346 0 0 0 .077 0 .364.364 0 0 0 .143-.058.386.386 0 0 0 .062-.6v-.008Zm-1.983.754a.387.387 0 0 0-.154.531.4.4 0 0 0 .54.152.387.387 0 0 0 .154-.53.4.4 0 0 0-.54-.153Zm-1.508.82a.387.387 0 0 0-.154.532.4.4 0 0 0 .54.152.387.387 0 0 0 .154-.531.4.4 0 0 0-.54-.153ZM3.3 16.416a.387.387 0 0 0-.155.531.4.4 0 0 0 .54.152.387.387 0 0 0 .154-.53.4.4 0 0 0-.54-.153Zm1.508-.82a.387.387 0 0 0-.155.53.4.4 0 0 0 .54.153.387.387 0 0 0 .154-.53.4.4 0 0 0-.54-.153Zm15.15 1.707a.387.387 0 0 0 .28.666c.22 0 .397-.175.397-.39a.388.388 0 0 0-.115-.276.414.414 0 0 0-.562 0Zm-1.035-.887a.4.4 0 0 0-.54.153.387.387 0 0 0 .155.53.4.4 0 0 0 .54-.152.387.387 0 0 0-.155-.53Zm-3.016-1.641a.4.4 0 0 0-.536.165.388.388 0 0 0 .167.527.4.4 0 0 0 .533-.16.388.388 0 0 0-.16-.53c-.002 0-.003 0-.004-.002Zm1.508.821a.4.4 0 0 0-.54.152.387.387 0 0 0 .155.531.4.4 0 0 0 .54-.152.387.387 0 0 0-.155-.531Zm-3.016-1.641a.4.4 0 0 0-.54.153.387.387 0 0 0 .155.53.4.4 0 0 0 .54-.152.387.387 0 0 0-.155-.53Zm-1.333-.629a.316.316 0 0 0-.038-.066.305.305 0 0 0-.11-.108.325.325 0 0 0-.142-.058.401.401 0 0 0-.36.105.462.462 0 0 0-.085.127.32.32 0 0 0-.021.074.369.369 0 0 0 0 .153.35.35 0 0 0 .06.14c.013.022.03.042.047.061a.4.4 0 0 0 .281.113.346.346 0 0 0 .078 0 .364.364 0 0 0 .143-.058.305.305 0 0 0 .109-.108.317.317 0 0 0 .06-.14.369.369 0 0 0 0-.153.32.32 0 0 0-.022-.082ZM10.89 2.472a.364.364 0 0 0 .143.059.386.386 0 0 0 .229-.022.4.4 0 0 0 .238-.285.369.369 0 0 0 0-.152.35.35 0 0 0-.11-.2.4.4 0 0 0-.432-.093.425.425 0 0 0-.214.21.35.35 0 0 0-.022.075.388.388 0 0 0 .169.408Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.111,
    cy: 5.508,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.111,
    cy: 3.828,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.111,
    cy: 7.187,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.111,
    cy: 8.867,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.478 10.396a.442.442 0 0 0-.087-.125.4.4 0 0 0-.647.125.35.35 0 0 0-.022.075.388.388 0 0 0 .169.4.364.364 0 0 0 .143.059.386.386 0 0 0 .228-.022.4.4 0 0 0 .238-.285.369.369 0 0 0 0-.152.32.32 0 0 0-.022-.075Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimation);
export default __webpack_public_path__ + "static/media/animation.841d9a7a86162dfa2e43e0031929692b.svg";
export { ForwardRef as ReactComponent };